<app-cover-static-paper />
<app-why-love-paper />
<app-static-card-paper />
<!-- <section>
  <h1 class="mb-10 font-bold text-2xl text-center xl:text-6xl md:text-4xl lg:text-5xl">BrowsePast Papers by subjects</h1>
  <app-browse-subjects />
</section> -->
<app-explore-tools />
